import {
  mapPerBasicLanguageToPerCountry,
  PerBasicLanguage,
  SiteCountry,
} from '../data/models/locale'

export const getCoronaLink = (country: SiteCountry) => {
  const links: PerBasicLanguage<string> = {
    en: 'https://stories.srprs.me/all-stories/coronavirus',
    nl: 'https://stories.srprs.me/alle-verhalen/coronavirus',
    dk: 'https://stories.srprs.me/alle-historier/coronavirus',
  }

  return mapPerBasicLanguageToPerCountry(links)[country]
}
